import styled from 'styled-components';

export const BreadCrumbOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        align-self: flex-start;
    `
);

export const BreadCrumbLinkWrap = styled.div(
    props => `
        padding-right: ${props.theme.spacing.small.s7};
    `
);

export const BreadCrumbLink = styled.a(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight:${props.theme.font.fontWeight.bold};

        &:hover{
            color: ${props.theme.colors.blue.base}
        }

        &.active{
            color: ${props.theme.colors.white.base}
        }
    `
);

export const BreadCrumbArrow = styled.span(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
    `
);

